module.exports = __webpack_public_path__ + "static/media/gem.386bb248.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/gem.svg
// module id = 509
// module chunks = 0